/* eslint-disable @typescript-eslint/no-explicit-any*/
import {
  PIX_REGISTER_DETAILS,
  PIX_GET_ALL_KEYS,
  PIX_VERIFY_CODE_DETAILS,
  PIX_PORTABILITY_SUCCESS,
  PIX_OWNERSHIP_CLAIM_SUCCESS,
  PIX_CANCEL_PORTABILITY_SUCCESS,
  PIX_DELETE_SUCCESS,
  PIX_DECODE_QR_CODE,
  SET_PIX_PSPS,
  SET_PIX_PSP_ERROR,
} from '~/actions/actionTypes';

const initialState: reducers.PixReducer = {
  registerDetails: null,
  pixKeys: null,
  verifyCodeSuccess: false,
  portabilitySuccess: false,
  ownershipClaimSuccess: false,
  cancelPortabilitySuccess: false,
  pixDeleteSuccess: false,
  decodeQrCodeDetails: null,
  psp: [],
  pspError: false,
};

const pixReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PIX_REGISTER_DETAILS:
      state = {
        ...state,
        registerDetails: action.payload,
      };
      break;

    case PIX_GET_ALL_KEYS:
      state = {
        ...state,
        pixKeys: action.payload,
      };
      break;

    case PIX_VERIFY_CODE_DETAILS:
      state = {
        ...state,
        verifyCodeSuccess: action.payload,
      };
      break;

    case PIX_PORTABILITY_SUCCESS:
      state = {
        ...state,
        portabilitySuccess: action.payload,
      };
      break;

    case PIX_OWNERSHIP_CLAIM_SUCCESS:
      state = {
        ...state,
        ownershipClaimSuccess: action.payload,
      };
      break;

    case PIX_CANCEL_PORTABILITY_SUCCESS:
      state = {
        ...state,
        cancelPortabilitySuccess: action.payload,
      };
      break;

    case PIX_DELETE_SUCCESS:
      state = {
        ...state,
        pixKeys: (state?.pixKeys || []).filter(
          ({ key }) => key !== action.payload
        ),
        pixDeleteSuccess: action.payload,
      };
      break;

    case PIX_DECODE_QR_CODE:
      state = {
        ...state,
        decodeQrCodeDetails: action.payload,
      };
      break;

    case SET_PIX_PSPS:
      state = {
        ...state,
        psp: action.payload,
      };
      break;

    case SET_PIX_PSP_ERROR:
      state = {
        ...state,
        pspError: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default pixReducer;
